import { Component, Vue } from 'vue-property-decorator';
import WithRender from './developers.html';
import './developers.css';
import Credentials from './credentials';

@WithRender
@Component({
  components: {
    Credentials
  }
})
export default class Developers extends Vue {
}
